@if (!(loading | async)) {
  <div>
    <div class="row">
      <div class="column twelve">
        <h4 class="heading-sub-section" dsContent [contentPath]="'claims.fnol.duplicateFound'"></h4>
        <p class="pad-top-10" dsContent [contentPath]="'claims.fnol.duplicateFoundText'"></p>
      </div>
    </div>
    <div class="row pad-top-30">
      <div class="column twelve">
        @if (draftClaimsList?.length && draftClaimsList.length > 0) {
          <div class="row">
            <ds-claim-list
              [claimList]="draftClaimsList"
              [risks]="risks"
              [isDraft]="'true'"
              [hideDelete]="'true'"
              [sidebarPresent]="sidebarPresent"
              (resumeDraftClaimEvent)="resumeDraftClaim($event)"
            ></ds-claim-list>
          </div>
        }
        <button
          ds-button
          type="button"
          (click)="startANewClaim()"
          dsContent
          [contentPath]="'claims.fnol.reportNewClaimBtn'"
        ></button>
      </div>
    </div>
  </div>
}
